import Vue from 'vue'
import Vuex from 'vuex'
import { AuthModule } from './modules/auth'
import { AppModule } from './modules/app'

Vue.use(Vuex)

const store = new Vuex.Store<any>({
    modules: {
        auth: AuthModule,
        app: AppModule
    }
})

export default store
